module.exports = __webpack_public_path__ + "static/media/refreshRequest.651e4da7.svg";